import { Dispatch } from "redux";

import { AppState } from "../definitions";
import { updateSyncMapItemData } from "./genericActions";

export function updateSyncMapItemIsCoBrowserEnabled(enabled: boolean) {
    return async (dispatch: Dispatch, getState: () => AppState) => {
        const { session } = getState();
        if (!session) {
            return;
        }

        const { conversationSid, syncMapItemData, syncMap } = session;

        if (!conversationSid || !syncMap) {
            return;
        }

        const newData = {
            ...syncMapItemData,
            isCoBrowserEnabled: enabled
        };

        await syncMap?.update(conversationSid, newData);

        dispatch(updateSyncMapItemData(newData));
    };
}
